let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1642081189972x997170020892016600',
        data: '2023, February 15',
    },
    {
        id: 2,
        trackTitle: "Entry-level",
        trackSubtitle: "For Junior specialists",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Entry-level',
        trackLink: 'https://geekle.us/ticketfree/1642080322598x513959232577208300',
        data: '2023, February 14',
    },
];

export default PackagesItem;
